// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"223":"ddd5d5b0","304":"86ddfb5a","924":"ede2b0ba"}[chunkId] + ".js";
};